import i18next, { InitOptions } from 'i18next'

const isDevMode = process.env.VUE_APP_ENVIRONMENT === 'development'
const loadPathDomain = window.location.hostname + (isDevMode ? ':8000' : '')

const findSimpleLang = () => {
  if(Array.isArray(navigator.languages) && navigator.languages.length > 0) {
    const hyphenIndex = navigator.languages[0].indexOf('-')
    return (hyphenIndex > -1) ? navigator.languages[0].substring(0, hyphenIndex) : navigator.languages[0]
  }
  return navigator.language
}

const i18nextConfig: InitOptions = {
  debug: (process.env.i18_DEBUG) ? (process.env.i18_DEBUG === 'true') : false,
  lng: i18next.language || findSimpleLang(),
  fallbackLng: 'en',    // the key is the fallback
  fallbackNS: '',		// not  using namespaces
  returnEmptyString: false,
  // allow keys to be phrases having `:`, `.`
  nsSeparator: false,
  keySeparator: false,
  backend: {
    loadPath: `https://${loadPathDomain}/api/translations/${i18next.language || findSimpleLang()}.json`
  },
  parseMissingKeyHandler: (key: string) => {
    //isDevMode && console.debug('###### parseMissingKey: ', key);
    return isDevMode ? `»${key}«` : key;
  }
}

export default i18nextConfig
